import { Platform } from 'react-native';
import { CaretLeft, ArrowLeft } from '../Icons';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '../../navigationApp/types';
import { ThemedTouchableOpacity } from '../../theme/Components';
import {useDarkMode} from '@app/utils';
import { useAppSelector } from '@app/store/hooks';


type BackButtonProps = NativeStackNavigationProp<PrivateStackParamList , keyof PrivateStackParamList>

const BackButton = ({ navigation , pageName } : {navigation : BackButtonProps , pageName? :keyof PrivateStackParamList }) => {
  const isDarkMode = useDarkMode()
  const {showHome} = useAppSelector(state => state.platformParams)
  const handleGoBack = () => {
    if (navigation.canGoBack() && showHome) {
      navigation.goBack();
    } else {
      console.log('No screen to go back to.');
    }
  };
  return (
    <ThemedTouchableOpacity
      hitSlop={{ left: 10, right: 10, top: 10, bottom: 10 }}
      eventName={pageName ? pageName + '_BACK' : undefined}
      onPress={handleGoBack}>
      {Platform.OS === 'ios' ? (
        <CaretLeft size={20} color={isDarkMode? '#fff':"#000000"} />
      ) : (
        <ArrowLeft size={18} color={isDarkMode? '#fff':"#000000"}  />
      )}
    </ThemedTouchableOpacity>
  );
};

export default BackButton;
